import { render, staticRenderFns } from "./Prealert.vue?vue&type=template&id=57882525&"
import script from "./Prealert.vue?vue&type=script&lang=js&"
export * from "./Prealert.vue?vue&type=script&lang=js&"
import style0 from "./Prealert.vue?vue&type=style&index=0&id=57882525&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports